// extracted by mini-css-extract-plugin
export default {"resetLink":"ResetFilterLink_resetLink__NqZUV","placeHolderShimmer":"ResetFilterLink_placeHolderShimmer__u7ri7"};